import { render, staticRenderFns } from "./TipoVehiculo.vue?vue&type=template&id=623554f4"
import script from "./TipoVehiculo.vue?vue&type=script&lang=js"
export * from "./TipoVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports